import * as z from 'zod'

export const TelegramSchema = z.object({
	username: z.string().nonempty(),
	alias: z.string().optional()
})

export type TelegramType = z.TypeOf<typeof TelegramSchema>